import * as PropTypes from 'prop-types'
import * as React from 'react'
import { css } from 'glamor'
import { isElement } from '../../utils'
import { IItemProps } from './item'

const variants = ['checkbox', 'radio']

function cloneItem<TValue>(
  item: React.ReactElement<IItemProps<TValue>>,
  value: TValue[],
  onChange: (event: React.SyntheticEvent, value: TValue[]) => void,
  variant: 'checkbox' | 'radio'
) {
  return React.cloneElement(item, {
    checklistItem: true,
    checked: value && item.props.value && value.includes(item.props.value),
    onClick: (event: React.SyntheticEvent) => {
      const valueWithDefault = value || []
      if (variant === 'checkbox') {
        const selectedValues = item.props.value
          ? valueWithDefault.includes(item.props.value)
            ? valueWithDefault.filter(val => val !== item.props.value)
            : valueWithDefault.concat([item.props.value])
          : valueWithDefault

        onChange(event, selectedValues)
      } else if (variant === 'radio') {
        onChange(event, item.props.value ? [item.props.value] : [])
      }

      if (item.props.onClick) item.props.onClick(event, false)
    },
  })
}

interface IChecklistProps<TValue> {
  children: React.ReactNode
  value: TValue[]
  variant: 'checkbox' | 'radio'
  onChange: (event: React.SyntheticEvent, value: TValue[]) => void
}

/**
 * CheckList
 *
 * Implemented as a controlled component, will highlight the item
 * in value (or items if an array) as checked.
 */
export default function Checklist<TValue>({ children, value, variant, onChange }: IChecklistProps<TValue>) {
  return (
    <ul {...css({ padding: 0 })}>
      {React.Children.map(children, child => (isElement(child) ? cloneItem(child, value, onChange, variant) : child))}
    </ul>
  )
}

Checklist.propTypes = {
  children: PropTypes.node,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(variants),
}

Checklist.defaultProps = {
  variant: 'checkbox',
}
